import { Alert } from "react-bootstrap";
import { Button } from "../../stories/Buttons/Button";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import { useMediaQuery } from "react-responsive";
import { isSafeUrl } from "../../utils";

/**
 * AssessmentMessage Component
 * Displays an alert with actionable messages based on assessment status.
 * @returns {JSX.Element | null} - Rendered component or null
 */

export function AssessmentMessage({ assessment, test_id, bId, testFlag, selectedTest, reportReady,reportLink }) {
  const isTablet = useMediaQuery({ maxWidth: 1200 });
  const isMobile = useMediaQuery({ maxWidth: 840 });
  const safeReportLink = isSafeUrl(reportLink) ? reportLink : undefined;

  if (testFlag === 1 && assessment.hasFilledAssessment && !assessment.canEditAssessment && reportReady && !bId) {
    return (
      <Alert
        className="mt-3 custom-width-for-assessment row ms-0"
        variant="dark"
        fade={false}
      >
        <span className="col-md-6">
          <strong>
            <Link
              to={reportLink}
              className="alert-link"
            >
              View your result
            </Link>
          </strong>
          <p className="text-muted ageo-medium">
            {" "}
            Our doctor has reviewed your results. Your report has been published
            and is ready to view.
          </p>
        </span>
        <div className={`col-md-6 d-flex justify-content-end align-items-center ${isMobile ? "flex-column justify-content-center gap-3" : "justify-content-end"}`}>
          <Button
            className={`btn-white ${isMobile ? "w-100 me-0 mb-0" : "me-3"}`}
            href={safeReportLink}
            color="primary"
            label="View report"
          />
          <Button
            href={`/assessment-details/${selectedTest?.id}`}
            variant="dark"
            className={`pt-2 btn-green justify-content-end ${isMobile && "w-100"}`}
            size="sm"
            label="View assessment"
          />
        </div>
      </Alert>
    );
  }

  if (testFlag === 1 && !assessment.canEditAssessment && !assessment.hasFilledAssessment && !reportReady && !bId) {
    return (
      <Alert
        className="mt-3 custom-width-for-assessment row ms-0"
        variant="dark"
        fade={false}
      >
        <span className="col-md-12">
          <strong>
            <Link
              to={reportLink}
              className="alert-link"
            >
              Your test status
            </Link>
          </strong>
          <p className="text-muted ageo-medium">
            {selectedTest.test_kit_status !== "report-in-review" ? "Your kit has been received by our laboratory. Analysis of your sample is in progress." :"Your sample has been analysed by our laboratory. Your results are in review with our doctor."}
          </p>
        </span>
      </Alert>
    );
  }

    if (testFlag === 1 && !assessment.hasFilledAssessment && reportReady && !bId) {
    return (
      <Alert
        className="mt-3 custom-width-for-assessment row ms-0"
        variant="dark"
        fade={false}
      >
        <span className="col-md-8">
          <strong>
            <Link
              to={reportLink}
              className="alert-link"
            >
              View your result
            </Link>
          </strong>
          <p className="text-muted ageo-medium">
            {" "}
            Our doctor has reviewed your results. Your report has been published
            and is ready to view.
          </p>
        </span>
        <div className={`col-md-4 d-flex justify-content-end align-items-center ${isMobile ? "flex-column justify-content-center gap-3" : "justify-content-end"}`}>
          <Button
            className={`btn-white ${isMobile ? "w-100 me-0 mb-0" : "me-3"}`}
            href={safeReportLink}
            color="primary"
            label="View report"
          />
        </div>
      </Alert>
    );
  }

  if (bId && !reportReady) {
        return (
      <Alert
        className="mt-3 custom-width-for-assessment row ms-0"
        variant="dark"
        fade={false}
      >
        <span className="col-md-8">
          <strong>
            <Link
              to={`/bloods/boots/assessment-details/${selectedTest?.test_kit_type}/${selectedTest?.bid}`}
              className="alert-link"
            >
              View your Health Assessment
            </Link>
          </strong>
          <p className="text-muted ageo-medium">
            {" "}
            Your Health Assessment has been completed and submitted. You can
            view your responses here.
          </p>
        </span>
        <div className="col-md-4 d-inline-flex justify-content-end align-items-center">
          <Button
            href={`/bloods/boots/assessment-details/${selectedTest?.test_kit_type}/${selectedTest?.bid}`}
            variant="dark"
            className={`pt-2 btn-green justify-content-end ${isMobile && "w-100"}`}
            size="sm"
            label="View assessment"
          />
        </div>
      </Alert>
    );
  }

  if (bId && reportReady) {
       return (
        <Alert
          className="mt-3 custom-width-for-assessment row ms-0"
          variant="dark"
          fade={false}
        >
          <span className="col-md-6">
            <strong>
              <Link
                to={reportLink}
                className="alert-link"
              >
                View your result
              </Link>
            </strong>
            <p className="text-muted ageo-medium">
              {" "}
              Our doctor has reviewed your results. Your report has been published
              and is ready to view.
            </p>
          </span>
          <div className={`col-md-6 d-flex justify-content-end align-items-center ${isMobile ? "flex-column justify-content-center gap-3" : "justify-content-end"}`}>
            <Button
              className={`btn-white ${isMobile ? "w-100 me-0 mb-0" : "me-3"}`}
              href={safeReportLink}
              color="primary"
              label="View report"
            />
            <Button
              href={`/bloods/boots/assessment-details/${selectedTest?.test_kit_type}/${selectedTest?.bid}`}
              variant="dark"
              className={`pt-2 btn-green justify-content-end ${isMobile && "w-100"}`}
              size="sm"
              label="View assessment"
            />
          </div>
      </Alert>
    );
  }
  

  if (testFlag === 1 && assessment.hasFilledAssessment && !assessment.canEditAssessment && !reportReady && !bId) {
    return (
      <Alert
        className="mt-3 custom-width-for-assessment row ms-0"
        variant="dark"
        fade={false}
      >
        <span className="col-md-8">
          <strong>
            <Link
              to={`/assessment-details/${selectedTest?.id}`}
              className="alert-link"
            >
              View your Health Assessment
            </Link>
          </strong>
          <p className="text-muted ageo-medium">
            {" "}
            Your Health Assessment has been completed and submitted. You can
            view your responses here.
          </p>
        </span>
        <div className="col-md-4 d-inline-flex justify-content-end align-items-center">
          <Button
            href={`/assessment-details/${selectedTest?.id}`}
            variant="dark"
            className={`pt-2 btn-green justify-content-end ${isMobile && "w-100"}`}
            size="sm"
            label="View assessment"
          />
        </div>
      </Alert>
    );
  }

  // If filled assessment, show edit message
  if (assessment.hasFilledAssessment && !bId && !reportReady) {
    return (
      // <Alert className="mt-3 rounded" variant="dark" fade={false}>
      //   Feel free to edit your Health Assessment to provide the most accurate
      //   details for our doctor.
      //   <br />
      //   <Button
      //     href={`/assessment-details/${test_id}`}
      //     color="dark"
      //     className="mt-2 btn-dark"
      //     size="sm"
      //     label="Edit assessment"
      //   />

      // </Alert>
      <Alert className="mt-3 custom-width-for-assessment row ms-0" variant="dark" fade={false}>
      <span className="col-md-8">
        <strong>
          <Link to={`/assessment-details/${test_id}`} className="alert-link">
            Edit your Health Assessment
          </Link>
        </strong>
        <p className="text-muted ageo-medium">Feel free to edit your Health Assessment to provide the most accurate details for our doctor.</p>
      </span>
      <div className="col-md-4 d-inline-flex justify-content-end align-items-center">
        <Button
          href={`/assessment-details/${test_id}`}
          variant="dark"
          className={`pt-2 btn-green justify-content-end ${isMobile && "w-100"}`}
          size="sm"
          label='Edit assessment'
        />
      </div>
    </Alert>
    );
  }

  // Otherwise - there are no assessment yet
  return (
    <Alert className="mt-3 custom-width-for-assessment row ms-0" variant="dark" fade={false}>
      <span className="col-md-8">
        <button className="btn-required ageo-bold"><span className="dot"></span><span className="pt-1"> Action required</span></button><br/>
        <strong>
          <Link to={`/assessment/${test_id}/1`} className="alert-link">
            Complete your Health Assessment
          </Link>
        </strong>
        <p className="text-muted ageo-medium">Our reviewing physician requires your medical and lifestyle history before assessing your {selectedTest.test_kit_type_name.toLowerCase()}. Without this context, we cannot validate your diagnosis or provide clinical recommendations.</p>
      </span>
      <div className="col-md-4 d-inline-flex justify-content-end align-items-center">
        <Button
          href={`/assessment/${test_id}/1`}
          variant="dark"
          className={`pt-2 btn-green justify-content-end ${isMobile && "w-100"}`}
          size="sm"
          label='Complete assessment'
        />
      </div>
    </Alert>
  );
}

AssessmentMessage.propTypes = {
  assessment: PropTypes.shape({
    canEditAssessment: PropTypes.bool.isRequired,
    hasFilledAssessment: PropTypes.bool.isRequired,
  }).isRequired,
  test_id: PropTypes.string.isRequired,
  bId: PropTypes.string, 
};